import ef from 'ef/ef';
const AhoyService = require('services/ahoy-service');
const BlockView = require('views/block/base-block-view');
const DOMPurify = require('dompurify');
import IconLoadService from 'services/icon-load-service';
import { KeybindingService, keys } from 'services/keybinding-service';
import LocaleService from 'services/locale-service';

const { ArrowLeft, ArrowRight, Enter, Space, Tab } = keys;

const DEFAULT_ICONS = {
  visited: {
    icon_prefix: 'fal',
    icon_name: 'fa-check-circle',
  },
  unvisited: {
    icon_prefix: 'fal',
    icon_name: 'fa-circle',
  },
  current: {
    icon_prefix: 'fas',
    icon_name: 'fa-check-circle',
  },
};

const NEW_ICONS = {
  visited: 'fal fa-check-circle',
  unvisited: 'fal fa-circle',
  current: 'fas fa-check-circle',
};

var TabView = BlockView.extend({
  initialize: function () {
    if (this.model.get('default') === undefined || this.model.get('default') === true) {
      this.model.set('default', 0);
    }
    this.icon = this.model.get('defaultIcons');

    if (this.icon) {
      if (this.isIconLegacyVersion(this.icon)) {
        this.icon.visited = DEFAULT_ICONS.visited;
        this.icon.unvisited = DEFAULT_ICONS.unvisited;
        this.icon.current = DEFAULT_ICONS.current;
      } else {
        this.icon.visited = NEW_ICONS.visited;
        this.icon.unvisited = NEW_ICONS.unvisited;
        this.icon.current = NEW_ICONS.current;
      }
    }
    BlockView.prototype.initialize.apply(this, arguments);
  },

  load: function () {
    this.renderMultipleNestedBlocks('tabs');
    this.model.get('tabs').forEach((element, index) => {
      const index_id = index === 0 ? this.model.cid : `${this.model.cid}-${index}`;
      //legacy icon, should be removed.
      if (this.icon) {
        if (this.isIconLegacyVersion(this.icon)) {
          IconLoadService.applyIcon(
            this.icon.visited.icon_name,
            index_id,
            this.icon.visited.customClasses || null,
            this.icon.visited.icon_prefix
          );
          IconLoadService.applyIcon(
            this.icon.unvisited.icon_name,
            index_id,
            this.icon.unvisited.customClasses || null,
            this.icon.unvisited.icon_prefix
          );
          IconLoadService.applyIcon(
            this.icon.current.icon_name,
            index_id,
            this.icon.current.customClasses || null,
            this.icon.current.icon_prefix
          );
        } else {
          IconLoadService.applyIcon(this.icon.visited, index_id);
          IconLoadService.applyIcon(this.icon.unvisited, index_id);
          IconLoadService.applyIcon(this.icon.current, index_id);
        }
      }

      if (this.model.get('stepper')) {
        IconLoadService.applyIcon('fal fa-check', index_id);
      }

      //legacy for icon, should be removed.
      if (element.iconTab && element.iconTab.icon_prefix) {
        IconLoadService.applyIcon(
          element.iconTab.icon_name,
          index_id,
          element.iconTab.customClasses || null,
          element.iconTab.icon_prefix
        );
      } else {
        if (typeof element.icon === 'string') {
          IconLoadService.applyIcon(element.icon, index_id);
        }
      }
    });
    const completed = [];
    const checkComplete = this.checkComplete.bind(this);
    let defaultTab = this.model.get('default');
    if (typeof defaultTab === 'number' && defaultTab >= 0) {
      if (this.model.get('required')) {
        completed.push(this.model.get('tabs')[this.model.get('default')].id);
      }
      AhoyService.track('tab', { action: 'viewed', id: this.model.get('tabs')[defaultTab].id });
    } else {
      AhoyService.track('tab', { action: 'tabs-hidden', id: -1 });
    }

    const $activeTab = this.$('.tab.active');
    const activeTabIndex = $activeTab.data('index') + 1;
    const ariaCompleteLabel = $activeTab.find('a[data-toggle="tab"]').data('aria-complete-label');
    const activeTabAriaLabel = `${ariaCompleteLabel}, ${LocaleService.t('tabText', {
      tabIndex: activeTabIndex,
      tabLength: this.model.get('tabs').length,
    })}`;

    $activeTab.attr({
      'aria-label': activeTabAriaLabel,
    });

    [...this.$('.tab').not('.active')].forEach(el => {
      const dataLabel = $(el).find('a[data-toggle="tab"]').data('aria-not-complete-label');
      const index = $(el).data('index') + 1;
      const tabAriaLabel = `${dataLabel}, ${LocaleService.t('tabText', {
        tabIndex: index,
        tabLength: this.model.get('tabs').length,
      })}`;
      $(el).attr({
        'aria-label': tabAriaLabel,
      });
    });

    this.delegate('keydown', '.tab', e => {
      return KeybindingService.with(e).bind(
        [Enter, Space],
        () => {
          e.preventDefault();
          $(e.target).find('a').click();
          return false;
        },
        ArrowLeft,
        ({ target: { previousElementSibling } }) => {
          if (!previousElementSibling) {
            previousElementSibling = this.el.querySelector('.tabs').lastElementChild;
          }
          previousElementSibling.focus();
          const tabLink = $(previousElementSibling).find('a');
          tabLink.click();
          //bootstrap sets tabindex on the <a> when clicked, but we're using the li as the tabble element
          tabLink.attr({ tabindex: '-1' });
          return false;
        },
        ArrowRight,
        ({ target: { nextElementSibling } }) => {
          if (!nextElementSibling) {
            nextElementSibling = this.el.querySelector('.tabs').firstElementChild;
          }
          nextElementSibling && nextElementSibling.focus();
          const tabLink = $(nextElementSibling).find('a');
          tabLink.click();
          tabLink.attr({ tabindex: '-1' });
          return false;
        }
      );
    });

    this.$('a[data-toggle="tab"]').on('shown.bs.tab', e => {
      const $target = $(e.target);
      const $relatedTarget = $(e.relatedTarget);
      const $currentTab = $target.parent();
      const $previousTab = $relatedTarget.parent();
      const index = $currentTab.attr('data-index');
      const item = this.model.get('tabs')[index];
      Chaplin.mediator.publish('tab:change', item);

      const currentTabAriaLabel = `${$target.data('aria-complete-label')}, ${LocaleService.t('tabText', {
        tabIndex: Number(index) + 1,
        tabLength: this.model.get('tabs').length,
      })}`;

      $currentTab.attr({
        'aria-label': currentTabAriaLabel,
        tabindex: 0,
      });
      $previousTab.attr('tabindex', '-1');
      if (!$previousTab.hasClass('visited')) {
        $previousTab.addClass('visited');
      }

      var prevIcon;
      if ($previousTab.attr !== undefined) {
        prevIcon = 
          $('#' + $previousTab.attr('id'))
            .find('svg')
            .attr('id');
      }
      if (this.model.get('icon'))
        $('#' + prevIcon)
          .addClass(this.model.get('icon').visited)
          .attr('title', LocaleService.t('Visited Tab'));

      const icon = DOMPurify.sanitize($(e.target).closest('.tab').find('svg').attr('id'));
      if (this.model.get('icon')) $('#' + icon).removeClass(this.model.get('icon').visited);
      if (this.model.get('icon')) $('#' + icon).addClass(this.model.get('icon').current);

      if (completed.indexOf(item.id) === -1) {
        completed.push(item.id);
        AhoyService.track('tab', { action: 'viewed', id: e.currentTarget.id });
        checkComplete(completed);
      }

      if (item.reRenderOnShown) {
        this.reRenderCurrentTab(index);
      }
    });

    if (ef.forge_mode) {
      this.$('a[data-toggle="tab"]').on('click', e => {
        const item = e.currentTarget;
        this.$(item).tab('show');
      });
    }
  },

  isIconLegacyVersion(icon) {
    return typeof icon.visited === 'object' && typeof icon.unvisited === 'object' && typeof icon.current === 'object';
  },

  reRenderCurrentTab(index) {
    const item = this.model.get('tabs')[index];
    this.renderNestedBlocks(this.model.get('cid') + '-tabs-' + index + '-blocks', item.blocks);
  },
  checkComplete(completed) {
    if (completed.length === this.model.get('tabs').length) {
      AhoyService.track('tab', { action: 'completed' });
      this.readyToGo();
    }
  },
  play: function () {
    if (!this.model.get('required')) {
      this.readyToGo();
    }
  },
});

module.exports = TabView;
